export const siteConfig = {
  name: '1024社区',
  tagline: '程序员技术交流与资源分享平台',
  description: '1024社区是专为程序员打造的技术交流平台，汇聚海量编程教程、开源项目、技术干货与资源分享。加入1024社区，与百万开发者共同学习、交流、成长，获取最新技术资讯与实战经验。',
  url: 'https://jxsbzl.cn',
  github: 'https://github.com/1024-community',
  email: 'contact@jxsbzl.cn',
  beian: '京ICP备2024000001号-1',
};